"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.palette = void 0;
var colors_1 = require("./colors");
var palette = {
  primary: {
    main: colors_1.colors.WomCTA
  },
  secondary: {
    main: colors_1.colors.WomCorp
  },
  error: {
    main: colors_1.colors.NotificacionesRojo
  },
  warning: {
    main: colors_1.colors.NotificacionesAmarillo
  },
  info: {
    main: colors_1.colors.WomCTA
  },
  success: {
    main: colors_1.colors.NotificacionesVerde
  },
  text: {
    primary: colors_1.colors.Neutros90,
    secondary: colors_1.colors.Neutros90,
    disabled: colors_1.colors.NeutrosDeshabilitado
  },
  action: {
    disabledBackground: colors_1.colors.Neutros20,
    disabled: colors_1.colors.Neutros0
  }
};
exports.palette = palette;